"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventorySubjectList = void 0;
const validator_1 = require("@leavy/validator");
const InventorySubject_1 = require("./InventorySubject");
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
class InventorySubjectList extends infrastructure_1.ValueObjectBase {
    constructor() {
        super(...arguments);
        this.subjects = [];
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.subjects)
            && this.subjects.every(x => x.isComplete())
            && this.subjects.some(x => x.type == InventorySubject_1.InventorySubjectType.ROOM));
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => InventorySubject_1.InventorySubject),
    __metadata("design:type", Array)
], InventorySubjectList.prototype, "subjects", void 0);
exports.InventorySubjectList = InventorySubjectList;
//# sourceMappingURL=InventorySubjectList.js.map